<script lang="ts">
    
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import { storeArticles, storeArticlesError, storeArticle } from "../scripts/blog";
    import { storeLanguage, lang_fr } from "../scripts/store";
    import { getArticles } from '../scripts/apiArticles';
    import { addNotificationError }  from "../scripts/toaster";
    import { redirectTo } from "../scripts/router1";
    import { idPageArticle } from "../scripts/router2";
    import Tile from '../components/Tile.svelte';

    onMount(async () => {
        window.scrollTo(0,0);
        getArticlesIfEmpty();
	});

    /**
     * getArticlesIfEmpty
     */
     function getArticlesIfEmpty() {
        if ($storeArticles.length <= 0) {
            const returnValue = getArticles();
            returnValue.then((data) => {
                if (!data) {
                    addNotificationError($storeArticlesError);
                };
            });
        }
    }

    /**
     * selectArticle
     * @param articleId
     */
    function selectArticle(articleId: number) {
        filterArticle(articleId);
        redirectTo(idPageArticle, "?id="+articleId);
    }

    /**
     * filterArticle
     * @param articleId
     */
    function filterArticle(articleId: number) {
        storeArticle.set($storeArticles.filter(item => {
            return (item.id == articleId);;
        })[0]);
    }

</script>
    
<style lang="scss">

    .blog {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__title {
            margin: 50px 0 50px 0;
            align-self: flex-start;
        }
        &__articles {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            margin: 0 32px 0 32px;
            width: 100%;
        }
        &__article {
            margin: 0 0 50px 0;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            background-color: $color-light-grey;
            box-shadow: 8px 8px 8px $color_text;
            border-radius: 20px 20px 20px 20px;
            min-height: 317px;
            width: 100%;
            &__photo {
                width: 100%;
                display: flex;
                flex-direction: column;;
                justify-content: center;
                align-items: center;
                &__img {
                    object-fit: cover;
                    object-position: 50% 0;
                    height: 167px;
                    width: 100%;
                    border-radius: 20px 20px 0 0;
                }
            }
            &__title {
                margin: 15px 0 0 0;
                max-width: 80%;
                overflow-y: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
            &__subtitle {
                margin: 15px 0 30px 0;
                max-width: 80%;
                overflow-y: hidden;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
            &__date {
                margin: 15px 0 0 0;
            }
            &__rate {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;
                &__img {
                    width: 20px;
                    margin: 0 10px 0 0;
                }
            }
        }
    }

    @include large {
        .blog {
            &__articles {
                flex-direction: row;
                align-items: flex-start;
            }
            &__article {
                cursor: pointer;
                height: 400px;
                width: 30%;
                overflow-y: hidden;
                &__title {
                    grid-area: title;
                    cursor: pointer;
                    &__a {
                        text-decoration: none;
                    }
                }
                &__photo {
                    &__img {
                        height: 200px;
                        width: 100%;
                    }
                }
            }
        }
    }

</style>

<div class="blog">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="Blog"/>
    {:else}
    <PageHeader props="Blog"/>
    {/if}
    <div class="bloc blog__bloc">
        <div class="blog__title">
            {#if ($storeLanguage == $lang_fr)}
            Vous retrouverez ici tous les articles de nos contributeurs.
            {:else}
            Here you will find all the articles of our contributors.
            {/if}
        </div>
        <div class="blog__articles">
            {#each $storeArticles as itemArticle, i}
            <div class="blog__article" on:click={() => selectArticle(itemArticle.id)} on:keydown={() => selectArticle(itemArticle.id)}>
                <div class="blog__article__photo">
                    <img class="blog__article__photo__img" src="../assets/images/articles/{itemArticle.id}_{itemArticle.photo}" alt="article">
                </div>
                <div class="blog__article__title">
                    <div class="font__h3">
                        {#if ($storeLanguage == $lang_fr)}
                        {itemArticle.title_fr}
                        {:else}
                        {itemArticle.title_fr}
                        {/if}
                    </div>
                </div>
                <div class="blog__article__subtitle font__h4">
                    {#if ($storeLanguage == $lang_fr)}
                    {itemArticle.subtitle_fr}
                    {:else}
                    {itemArticle.subtitle_fr}
                    {/if}
                </div>
            </div>
            {/each}
        </div>    
    </div>
</div>
